import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { Header } from 'foundations-components/transitional/components/Header';
import { StorefrontTabNav } from '../navigation/components/StorefrontTabNav';
import { SearchBar } from '../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './headers/ManageBuildDropdowns';
import { PageCallouts } from '../hero/components/PageCallouts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontDashboardWithTabs({
  children,
  interleaveBanners = false
}) {
  return /*#__PURE__*/_jsxs(DashboardPage, {
    headerComponent: /*#__PURE__*/_jsx(Header, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.headers.title"
      }),
      tabs: /*#__PURE__*/_jsx(StorefrontTabNav, {}),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "500",
        children: [/*#__PURE__*/_jsx(ManageBuildDropdowns, {}), /*#__PURE__*/_jsx(View, {
          minInlineSize: "300px",
          maxInlineSize: "500px",
          flexGrow: 1,
          children: /*#__PURE__*/_jsx(SearchBar, {})
        })]
      })
    }),
    children: [/*#__PURE__*/_jsx(PageCallouts, {
      showBanners: !interleaveBanners
    }), children]
  });
}